import { supabase } from "./supabaseClient";
import { accountFromMembership } from "../data/account";

// The account (agency) the signed-in login belongs to, from agency_members:
// { agencyId, name, role, showAdtao, maxPostcodes, features }, or null if the login isn't
// linked to one. A login linked to several gets its oldest (a switcher can come later).
// The database rules only let a login see its own memberships and accounts.
export async function fetchMyAccount(userId) {
  if (!userId) return null;
  const ask = columns => supabase
    .from("agency_members")
    .select(`role, created_at, agencies(${columns})`)
    .eq("user_id", userId)
    .order("created_at", { ascending: true })
    .limit(1);
  let { data, error } = await ask("id, name, show_adtao, max_postcodes_per_scan, features");
  // Before (or after undoing) the Audits stage 2 migration there's no features
  // column: load the account without it (every feature off).
  if (error) {
    console.error("fetchMyAccount", error);
    ({ data, error } = await ask("id, name, show_adtao, max_postcodes_per_scan"));
  }
  // Before the radius migration has run there's no postcode limit column:
  // load the account without it (the default limit applies) rather than
  // showing "No account yet".
  if (error) {
    console.error("fetchMyAccount", error);
    ({ data, error } = await ask("id, name, show_adtao"));
    if (error) console.error("fetchMyAccount (without postcode limit)", error);
  }
  return accountFromMembership(data && data[0]);
}
